export const parseGetParams = (search = '') => {
  const hashes = search.slice(search.indexOf('?') + 1).split('&');
  return hashes.reduce((params, hash) => {
    const [key, val] = hash.split('=');
    return {
      ...params,
      [key]: decodeURIComponent(val),
    }
  }, {});
};

export const constructGetParamsString = (params = {}) => {
  const keys = Object.keys(params);
  let result = '';
  for (let i = 0, l = keys.length; i < l; ++i) {
    if (i === 0) {
      result = `?${keys[i]}=${params[keys[i]]}`;
    } else {
      result = `${result}&${keys[i]}=${params[keys[i]]}`
    }
  }
  return result;
};
